<template>
  <div class="mobile-app-form">
    <div class="complete-message text-center" v-if="complete">
      We will pick up your enquiry soon and have you connected in no time.
    </div>

    <form class="form" id="mobile-app-form" v-if="!complete" @submit.prevent="killAutoSubmit()">
      <csrf></csrf>

      <div class="loading" v-if="busy">
        <div class="spinner">
          <i class="fas fa-circle-notch fast-spin"></i> Loading...
        </div>
      </div>

      <generic-error :error="genericError"></generic-error>

      <div class="row">
        <div class="col-md-6">
          <label>Full Name <strong>*</strong></label>
          <form-field-group v-bind:error="fullNameError">
            <div class="element">
              <input type="text" v-model="fullName" placeholder="Full Name"/>
            </div>
          </form-field-group>
        </div>
        <div class="col-md-6">
          <label>Business Name <strong>*</strong></label>
          <form-field-group v-bind:error="businessNameError">
            <div class="element">
              <input type="text" v-model="businessName" placeholder="Business Name"/>
            </div>
          </form-field-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label>Email Address <strong>*</strong></label>
          <form-field-group v-bind:error="emailError">
            <div class="element">
              <input type="text" v-model="email" placeholder="Email Address"/>
            </div>
          </form-field-group>
        </div>
        <div class="col-md-4">
          <label>Phone <strong>*</strong></label>
          <form-field-group v-bind:error="phoneError">
            <div class="element">
              <input type="text" v-model="phone" placeholder="Phone"/>
            </div>
          </form-field-group>
        </div>
        <div class="col-md-4">
          <label>Number of Subcontractors <strong>*</strong></label>
          <form-field-group v-bind:error="subcontractorsError">
            <div class="element">
              <input type="text" v-model="subcontractors" placeholder="Subcontractors"/>
            </div>
          </form-field-group>
        </div>
      </div>

      <!-- honeypot - hidden from real users, must stay empty -->
      <div class="d-none" aria-hidden="true">
        <label for="app_company_website">Company Website</label>
        <input type="text" id="app_company_website" v-model="companyWebsite" autocomplete="off" tabindex="-1"/>
      </div>

      <div class="row" v-if="captchaSitekey">
        <div class="col-12 d-flex justify-content-center mb-2">
          <div>
            <div ref="captcha"></div>
            <div class="vvERROR" v-if="captchaError">
              <i class="fas fa-exclamation-triangle"></i> {{ captchaError }}
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button style="float: none; display: inline-block;" class="button--gm-pink button--inverted ml-0" @click="validate()" data-text="Get the App">
          <span>G</span><span>e</span><span>t</span>
          <span>t</span><span>h</span><span>e</span>
          <span>A</span><span>p</span><span>p</span></button>
      </div>



    </form>

  </div>
</template>
<script type="text/javascript">
import FormFieldGroup from "./FormFieldGroup";

export default {
  components: {FormFieldGroup},
  props: {
    // signed timestamp from the server, so we can tell an instant bot post from a real visitor
    formStartedAt: {type: String, default: ''},
    captchaSitekey: {type: String, default: ''},
  },
  data: function () {
    return {
      complete: false,
      busy: false,

      genericError: null,

      // honeypot - hidden from real users, so anything in here is a bot
      companyWebsite: '',

      captchaWidgetId: null,
      captchaError: '',

      fullName: null,
      fullNameError: '',

      businessName: null,
      businessNameError: '',

      email: null,
      emailError: '',

      phone: null,
      phoneError: '',

      subcontractors: null,
      subcontractorsError: '',
    }
  },
  created() {
  },
  mounted() {
    this.renderCaptcha();
  },
  methods: {

    /**
     * The reCAPTCHA script is loaded in the page head, but this widget is created by Vue after
     * that script has already scanned the DOM, so it has to be rendered explicitly.
     */
    renderCaptcha: function (attempt = 0) {
      if (!this.captchaSitekey) {
        return;
      }

      if (window.grecaptcha && window.grecaptcha.render) {
        this.captchaWidgetId = window.grecaptcha.render(this.$refs.captcha, {sitekey: this.captchaSitekey});
        return;
      }

      // give the script up to ~10 seconds to arrive
      if (attempt < 50) {
        setTimeout(() => this.renderCaptcha(attempt + 1), 200);
      }
    },

    captchaResponse: function () {
      if (!this.captchaSitekey || this.captchaWidgetId === null || !window.grecaptcha) {
        return '';
      }

      return window.grecaptcha.getResponse(this.captchaWidgetId);
    },

    validate: function () {
      this.busy = true;

      this.genericError = '';
      this.captchaError = '';

      this.fullNameError = '';
      this.businessNameError = '';
      this.emailError = '';
      this.phoneError = '';
      this.subcontractorsError = '';

      if (this.fullName === null || this.fullName === '') {
        this.fullNameError = 'Please provide your full name';
      }
      if (this.businessName === null || this.businessName === '') {
        this.businessNameError = 'Please provide your business name';
      }
      if (this.email === null || this.email === '') {
        this.emailError = 'Please provide your email';
      } else if (!this.validateEmail(this.email)) {
        this.emailError = 'Please provide a valid email';
      }
      if (this.phone === null || this.phone === '') {
        this.phoneError = 'Please provide your phone';
      }
      if (this.subcontractors === null || this.subcontractors === '') {
        this.subcontractorsError = 'Please tell us how many subcontractors you have';
      }
      if (this.captchaSitekey && !this.captchaResponse()) {
        this.captchaError = 'Please confirm you are not a robot';
      }

      // Prevent form submission if errors are present
      if (
          this.fullNameError ||
          this.businessNameError ||
          this.emailError ||
          this.phoneError ||
          this.subcontractorsError ||
          this.captchaError
      ) {
        this.busy = false;
        return;
      }

      this.attemptSubmit();
    },
    attemptSubmit: function () {
      let self = this;

      let post = {};
      post['fullName'] = this.fullName;
      post['businessName'] = this.businessName;
      post['email'] = this.email;
      post['phone'] = this.phone;
      post['subcontractors'] = this.subcontractors;
      post['form_started_at'] = this.formStartedAt;
      post['company_website'] = this.companyWebsite;
      post['g-recaptcha-response'] = this.captchaResponse();

      // Call Ajax API
      fetch('/app/send_email', {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        body: JSON.stringify(post),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },

      })
          .then(
              function (response) {
                if (response.status !== 200) {
                  console.log('Looks like there was a problem. Status Code: ' +
                      response.status);
                  self.failed();
                  return;
                }

                response.json().then(function (body) {
                  // the endpoint answers false when it could not accept the enquiry - without
                  // this the form would claim success and the enquiry would vanish
                  if (body === false) {
                    self.failed();
                    return;
                  }

                  self.complete = true;
                  self.busy = false;
                });
              }
          )
          .catch(function (err) {
            console.log('Fetch Error :-S', err);
            self.failed();
          });
    },
    failed: function () {
      this.genericError = 'Sorry, we could not send your enquiry. Please check your details and try again.';
      this.busy = false;

      if (this.captchaWidgetId !== null && window.grecaptcha) {
        window.grecaptcha.reset(this.captchaWidgetId);
      }
    },
    validateEmail: function (email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    killAutoSubmit() {
      // Do nothing, vue is already doing this for us
    }
  }
}
</script>
